import { supabase } from '../App';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

async function getAuthHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {};
}

async function apiRequest(path, { method = 'GET', body, auth = false, query } = {}) {
  const url = new URL(path.replace(/^\//, ''), API_BASE_URL);
  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, value);
      }
    });
  }

  const headers = {};
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }
  if (auth) {
    Object.assign(headers, await getAuthHeaders());
  }

  let response;
  try {
    response = await fetch(url, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (err) {
    throw new ApiError(`Network error: ${err.message}`, 0, null);
  }

  if (response.status === 204) {
    return null;
  }

  const isJson = (response.headers.get('content-type') || '').includes('application/json');
  const payload = isJson ? await response.json().catch(() => null) : await response.text();

  if (!response.ok) {
    const message = (payload && payload.message) || response.statusText;
    throw new ApiError(Array.isArray(message) ? message.join(', ') : message, response.status, payload);
  }

  return payload;
}

export const apiGet = (path, opts) => apiRequest(path, { ...opts, method: 'GET' });
export const apiPost = (path, body, opts) => apiRequest(path, { ...opts, method: 'POST', body });
export const apiPatch = (path, body, opts) => apiRequest(path, { ...opts, method: 'PATCH', body });
export const apiDelete = (path, opts) => apiRequest(path, { ...opts, method: 'DELETE' });
